import { TableColumnType } from "./TableColumnType"

export type ColumnDescriptor = {
  type: TableColumnType
  title: string
  technicalName: string
  sortable: boolean
  dataCy?: string
  maxWidth?: string
  minWidth?: string
  widthPercent?: string //only matters when there is too much space, gives priority to the first columns
}

export type ColumnDescriptorMobile = {
  type: TableColumnType
  title?: string
  technicalName?: string
}
